let isSigninRequired: boolean | undefined = undefined;

export function getIsSigninRequired() {
    return !!isSigninRequired;
}

export function setIsSigninRequired(isSigninNeeded: boolean) {
    isSigninRequired = isSigninNeeded;
}
